import { autoinject } from 'aurelia-framework';
import { SessionData } from '_models/session-data';

@autoinject
export class ProductSelector {

    constructor(
        public sd: SessionData
    ) {

    }

    detached() {
        console.debug('resetting wizard state...');
        this.sd.resetWizard();
    }
}
